import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';  // Importa el hook useNavigate para la redirección
import { signOut } from 'aws-amplify/auth';
import './userprofile.css';

import logoUser from '../../assets/img/logo-userdefault.png';
import logoPlan from '../../assets/img/logo-plan.png';
import logoSugeridas from '../../assets/img/logo-sugeridas.png';
import logoFaq from '../../assets/img/logo-faq.png';
import logoTyc from '../../assets/img/logo-tyc.png';
import logoLogout from '../../assets/img/logo-logout.png';

const UserProfile = () => {
  const [isOpen, setIsOpen] = useState(false);
  const toggleMenu = () => setIsOpen(!isOpen);

  const navigate = useNavigate();  

  const handleFAQClick = () => {
    navigate('/faq');  
  };

  const handleTermsClick = () => {
    navigate('/terms');
  };

  const handleGuiaClick = () => {
    navigate('/guia');
  };

  return (
    <div className="user-profile">
      <img src={logoUser} alt="User" className="user-image" onClick={toggleMenu} />
      {isOpen && (
        <div className="dropdown-menu">
          <ul>
            <li onClick={() => navigate('/plan')}>
              <img src={logoPlan} alt="Mi plan" className="menu-icon" /> Mi plan
            </li>
            <li onClick={handleGuiaClick}>
              <img src={logoSugeridas} alt="Consultas sugeridas" className="menu-icon" /> Consultas sugeridas
            </li>
            <li onClick={handleFAQClick}>
              <img src={logoFaq} alt="FAQ" className="menu-icon" /> FAQ
            </li>
            <li onClick={handleTermsClick}>
              <img src={logoTyc} alt="Términos" className="menu-icon" /> Términos y condiciones
            </li>
            <li onClick={signOut}>
              <img src={logoLogout} alt="Cerrar sesión" className="menu-icon" /> Cerrar sesión
            </li>
          </ul>
        </div>
      )}
    </div>
  );
};

export default UserProfile;
